module.exports = __webpack_public_path__ + "img/thumb-brock-off.ab96f77c.jpg";